/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
} from './OrderType';

/**
 * 
 * @export
 * @interface TradeExecution
 */
export interface TradeExecution {
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    tradeId: string;
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    blockTradeId: string;
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    symbol: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof TradeExecution
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {OrderType}
     * @memberof TradeExecution
     */
    orderType: OrderType;
    /**
     * 
     * @type {number}
     * @memberof TradeExecution
     */
    limitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof TradeExecution
     */
    tradeQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof TradeExecution
     */
    pId: string;
}



/**
 * Check if a given object implements the TradeExecution interface.
 */
export function instanceOfTradeExecution(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeId" in value;
    isInstance = isInstance && "blockTradeId" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "orderType" in value;
    isInstance = isInstance && "limitPrice" in value;
    isInstance = isInstance && "tradeQuantity" in value;
    isInstance = isInstance && "pId" in value;

    return isInstance;
}

export function TradeExecutionFromJSON(json: any): TradeExecution {
    return TradeExecutionFromJSONTyped(json, false);
}

export function TradeExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeExecution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeId': json['trade_id'],
        'blockTradeId': json['block_trade_id'],
        'brokerId': json['broker_id'],
        'aC': json['a_c'],
        'symbol': json['symbol'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'orderType': OrderTypeFromJSON(json['order_type']),
        'limitPrice': json['limit_price'],
        'tradeQuantity': json['trade_quantity'],
        'pId': json['p_id'],
    };
}

export function TradeExecutionToJSON(value?: TradeExecution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_id': value.tradeId,
        'block_trade_id': value.blockTradeId,
        'broker_id': value.brokerId,
        'a_c': value.aC,
        'symbol': value.symbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'order_type': OrderTypeToJSON(value.orderType),
        'limit_price': value.limitPrice,
        'trade_quantity': value.tradeQuantity,
        'p_id': value.pId,
    };
}

